export default __webpack_public_path__ + "static/media/Dedicated Lanes for CAVs.a296d0c7.pdf";